export function mostrarMensajeErrorCatch(mensajeEnPantalla){
    toastr.error(mensajeEnPantalla + ', error de servidor.', 'Error!');
}

export function mostrarMensajeInformativo(mensajeEnPantalla){
   toastr.info(mensajeEnPantalla, '');
}

export function mostrarMensajeWarning(mensajeEnPantalla){
    toastr.warning(mensajeEnPantalla, '');
 }

export function mostrarMensajeExitoso(mensajeEnPantalla){
    toastr.success(mensajeEnPantalla, '');
}

export function mostrarMensajeError(mensajeEnPantalla){
    toastr.error('Los datos no se ' + mensajeEnPantalla + '.', 'Error!');
}